import { take, delay, fork, call, put, all, select } from 'redux-saga/effects';
import actionTypes from '../actionTypes';
import { callApi } from './callApi';
import {
  successTournamentCasinoRegister,
  failTournamentCasinoRegister,
  successTournamentCasinoUnregister,
  failTournamentCasinoUnregister,
} from '../actionCreators/tournamentCasinoRegister';
import { successBalanceTransfer } from '../actionCreators/transfers';
import { openDialog } from '../actionCreators/dialog';
import { getCurrentAccount } from '../../store/selectors';
import config from '../../config/config';

function* casinoTournamentRegistration(tournamentData, cb) {
  try {
    console.log('tournamentData = ',tournamentData);
    const { token } = yield select(getCurrentAccount);
    const gameData = tournamentData.tournamentGames[0];
    const params = {
      token: token,
      slot: gameData["id"],
      providerId : gameData["providerId"],
      tournamentId: tournamentData["tournamentId"],
      isFPP: tournamentData.payWithFPP
    };
    const response = yield call(callApi, `${config.API_TOURNAMENT_URL}/tour/casinoTournamentRegister`, 'POST', params);
    if(!response || !response.data) return false;
    const { wallets } = response.data.result;
    yield put(successTournamentCasinoRegister(response));
    yield cb(tournamentData);
    yield put(successBalanceTransfer());
  } catch (e) {
    const lowBalanceErr = "Low balance";
    if(e.response.data.result.message === lowBalanceErr) { 
      yield put(openDialog(
        'lowBalance', { data: e.response.data.result.tournament }
      ))
    } else {
      const errMessage = typeof e.response.data.result.message === 'string' ? e.response.data.result.message : 'Error';
      yield put(failTournamentCasinoRegister(errMessage, e));
    }
  }
}

export function* watchTournamentCasinoRegister() {
  while (true) {
    const action = yield take(actionTypes.TOURNAMENT_CASINO_REGISTER_REQUEST);
    yield fork(casinoTournamentRegistration, action.value, action.cb);
  }
}

function* casinoTournamentUnregistration(tournamentData) {
  try {
    const { token } = yield select(getCurrentAccount);
    const params = {
      token,
      tournamentId: tournamentData.tournamentId,
    };
    const response = yield call(callApi,`${config.API_TOURNAMENT_URL}/tour/casinoTournamentUnregister`, 'POST', params);
    yield put(successTournamentCasinoUnregister(response));
  } catch (e) {
    yield put(failTournamentCasinoUnregister(e.response.data.result.message, e));
  }
}

export function* watchTournamentCasinoUnregister() {
  while (true) {
    const action = yield take(actionTypes.TOURNAMENT_CASINO_UNREGISTER_REQUEST);
    yield fork(casinoTournamentUnregistration, action.value);
  }
}

export function* rootTournamentRegistration() {
  yield all([
    call(watchTournamentCasinoRegister),
    call(watchTournamentCasinoUnregister),
  ]);
}